import {useContext} from "react";

import {CoeditorAPIContext, type CoeditorAPI} from "./coeditor-context.ts";

/**
 * Hook providing an API for updating the external state of the Coeditor.
 */
export const useCoeditorAPIContext = (): CoeditorAPI =>
    useContext(CoeditorAPIContext);
